import React from 'react'
import './Hero.css'

import Logo from '../Components/assets/Logo/mainlogo.png';

function Hero({banner}) {
  return (
    <div>
       <section className="hero-section-revamp" id="home">
      {/* Navigation Bar */}
      <nav className="navbar-revamp">
        
        
        <ul className="nav-links-revamp">
          <li><a href="/">Home</a></li>
          <li><a href="/Gallery">Gallery</a></li>
          <li><a href="/Charters">Charters</a></li>
        </ul>
        <div className="logo-container-revamp">
          <img
            src={Logo}
            alt="EPIC Texas Charters Logo"
            className="logo-revamp"
          />
        </div>

        <div className="nav-button-revamp">
            <button>Contact Us</button>
        </div>
      </nav>

      {/* Main Content Container */}
      <div className="content-container-revamp">
        {/* Background Image */}
        <img
            src={banner}
          alt="Yacht sailing on water"
          className="background-image-revamp"
        />

        {/* Overlay */}
        <div className="overlay-revamp"></div>

        {/* Content Wrapper */}
        <div className="content-wrapper-revamp">
          {/* Left Side - Description */}
          <div className="text-content-revamp">
            <h2 className="tagline-revamp">
              Your Premier Texas Gulf Coast Yacht Charter Company
            </h2>
            <p className="description-revamp">
              Bring 5 of your closest friends and enjoy time on the water, the best way possible!
            </p>
            <a href="#book" className="cta-button-revamp">
              Book Your Adventure
            </a>
          </div>

          {/* Right Side - Main Title */}
          <div className="title-content-revamp">
            <h1 className="main-title-revamp">EPIC Texas</h1>
            <h2 className="subtitle-revamp">Charters</h2>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default Hero
